import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import AppLink from '../../../../../../routing/helpers/AppLink';
import {
  getControlClass,
  getControlDocumentation,
  getControlEfficiency,
  getControlState,
  getControlType,
  getFrequency,
} from '../../tools/totalEnergiesRiskControlTools';

export default function InformationTab({ elementID }) {
  const { moduleBridgeHex, page, filtersHex } = useParams();
  const userBridge = useSelector(
    (state) => state?.module?.[moduleBridgeHex]?.userBridge
  );
  const controlLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );

  return (
    <div className="container-fluid">
      {userBridge?.permissions?.level === 0 && (
        <div className="row">
          <div className="col-lg-12">
            <AppLink
              path="user_module_totalEnergiesRisk_control_edit"
              params={{
                moduleBridgeHex,
                controlHex: controlLevel1?.hex,
                page,
                filtersHex,
              }}
              className="btn btn-xs btn-success float-right"
            >
              Editar
            </AppLink>
          </div>
        </div>
      )}
      <div className="row mb-4">
        <div className="col-lg-6 mb-2">
          <Title>{getControlState(controlLevel1?.state)}</Title>
        </div>
        <div className="col-lg-6 mb-2">
          <Title>{controlLevel1?.code}</Title>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Nombre</Title>
          {controlLevel1?.name}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Descripción</Title>
          {controlLevel1?.description}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Proceso</Title>
          {controlLevel1?.process}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Subproceso</Title>
          {controlLevel1?.subProcess}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-2">
          <Title>Riesgo principal</Title>
          {controlLevel1?.riskCode}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Riesgos secundarios</Title>
          {controlLevel1?.secondaryRiskCodes?.length > 0 ? (
            <ul>
              {controlLevel1?.secondaryRiskCodes?.map((src) => (
                <li>{src}</li>
              ))}
            </ul>
          ) : (
            '--'
          )}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Tipo de control</Title>
          {getControlType(controlLevel1?.controlType)}
        </div>

        <div className="col-lg-6 mb-2">
          <Title>Clase de control</Title>
          {getControlClass(controlLevel1?.controlClass)}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Documentación del control</Title>
          {getControlDocumentation(controlLevel1?.controlDocumentation)}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Efectividad del control</Title>
          {getControlEfficiency(controlLevel1?.controlEfficiency)}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Frecuencia</Title>
          {getFrequency(controlLevel1?.frequency)}
        </div>
        <div className="col-lg-6 mb-2">
          <Title>Responsable</Title>
          {controlLevel1?.responsibleName || '--'}
        </div>
      </div>
    </div>
  );
}

const Title = styled.h3`
  font-size: 13px;
  font-weight: bold;
  margin: 0;
`;
